import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/shared/ui/EmptyState';

export function TrackersEmptyState() {
  const { t } = useTranslation('trackers');

  return (
    <EmptyState
      className="min-h-0 flex-1"
      title={t('trackersBoard.trackersEmptyState.noBriefsYet')}
      description={t('trackersBoard.trackersEmptyState.briefsWillAppearHereOnce')}
    />
  );
}
